module.exports = __webpack_public_path__ + "static/media/ghpages.8b4d5c51.png";